import React, { useState } from "react";
import RegistrationImage from "../../../Images/Registration.jpg";
import "./Registration.css";
import RegistrationInputs from "../../Inputs/RegistrationInputs/RegistrationInputs";

export default function Registration() {
  return (
    <>
      <div className="container-fluid vh-100 d-flex justify-content-center align-items-center registration">
        <div className="row justify-content-center align-items-center">
          <div className="col-12 col-md-6 ">
            <div className="m-3 d-flex justify-content-center align-items-center flex-column">
              <h1 className="text-center">حساب جديد</h1>
              <RegistrationInputs Signin={true} />
            </div>
          </div>
          <figure className="col-12 col-md-6 d-xxl-block d-md-block d-sm-none d-none ">
            <div className="m-3 position-relative">
              <div className="position-absolute start-0 end-0 top-0 bottom-0 layer"></div>
              <img src={RegistrationImage} alt="Login" className="" style={{ borderRadius: "10px" }} />
            </div>
          </figure>
        </div>
      </div>
    </>
  );
}
